// extracted by mini-css-extract-plugin
export default {"floatingLabel":"EditableInput_floatingLabel__rMSnJ","inputText":"EditableInput_inputText__FVHKa"};